import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomDataGrid from "../components/UI Helpers/DataGrid/CustomDataGrid";
import Settings from "../components/CommonAPICalls/Settings";
import CommonCalls from "../components/CommonAPICalls/CommonCalls";
import { dropdownValueFormatter, gridLinkValueFormatter, arrayValueFormatter } from '../components/MasterComponents/CommonFunctionalities';

function QurbaniDontationsGridPage() {
    const [userData, setUserData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
  
    const apiCalls = new CommonCalls();
    const navigate = useNavigate();
  
    useEffect(() => {
      getAllQurbaniBookings();
    }, [pageNumber, pageSize]);
  
    const getAllQurbaniBookings = async () => {
      setLoading(true);
      try {
        
        const apiResponse = await apiCalls.getAllQurbaniDonationUsers(pageNumber, pageSize);
        if (apiResponse) {
          setUserData(apiResponse?.data);
          setTotalRecords(apiResponse?.total_records);
          setLoading(false);
        }
      } catch (err) {
        setUserData([]);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };
  
    const onEmailClicked = (row, colKey) => {
      if (colKey === 'first_name') {
       
        sessionStorage.setItem('qurbani-first_name', `${row?.first_name} ${row?.last_name}`);
        sessionStorage.setItem('qurbani-donation_amount', row?.donation_amount);
        sessionStorage.setItem('qurbani-phone_number', row?.phone_number);
        sessionStorage.setItem('qurbani-transaction_from_account_number', row?.transaction_from_account_number);
        sessionStorage.setItem('qurbani-transaction_from_account_title', row?.transaction_from_account_title);
        sessionStorage.setItem('qurbani-donation_amount', row?.donation_amount);
        sessionStorage.setItem('qurbani-donation_amount_status', row?.donation_amount_status);
        navigate(`/portal/qurbani-donation/?qurbani=true&userid=${row?.qurbani_booking_id}`);
      }
    };
 
    const gridColumnHeaders = [
      { field: 'first_name', cellRenderer: gridLinkValueFormatter, customRendererLink: true, columnName: 'First Name' },
      { field: 'last_name', columnName: 'Last Name' },
      { field: 'donation_amount', columnName: 'Booking Amount' },
      { field: 'donation_amount_status', columnName: 'Booking Amount Status',customRendererLink: true, cellRenderer: (value) => dropdownValueFormatter(value, Settings.enumTypesForStatus), },
      { field: 'donation_type', customRendererLink: true, cellRenderer: (value) => dropdownValueFormatter(value, Settings.enumDonationType), columnName: 'Book Type' },
      { field: 'names_sacrifice_shares', customRendererLink: true, cellRenderer: (value) => arrayValueFormatter(value), columnName: 'Qurbani Share Names' },
      { field: 'cnic_number', columnName: 'CNIC' },
      { field: 'phone_number', columnName: 'Contact' },
      { field: 'email', columnName: 'Email' }, 
      { field: 'transaction_id', columnName: 'Transaction ID' },
      // { field: 'account_number', columnName: 'Account Number' },
      // { field: 'account_title', columnName: 'Acc. Title' },
      { field: 'total_portions', columnName: 'Total Portions' }
    ];
  
    return (
      <div className='listings_view_wrapper' style={{ padding: "20px" }}>
        <h1 className="h1_main mt-2">Qurbani Donation Users</h1>
  
        <CustomDataGrid
          columns={gridColumnHeaders}
          data={userData}
          pageSize={pageSize} 
          loadingState={loading}
          hideAddBtn={true}
          pagination={true}
          onCellClicked={onEmailClicked}
          totalRecords={totalRecords}
          currentPage={pageNumber}
          onPageChange={setPageNumber}
          onPageSizeChange={setPageSize}
          searchField={true}
          hideDeleteBtn={true}
          hideExcelBtn={false}
          excelFileBtnType={"QurbaniDonationUser"}
          excelFn={apiCalls.getAllQurbaniDonationUsers}
          excelArgument={[1,totalRecords]}
        />
      </div>
    );
}

export default QurbaniDontationsGridPage;